import { context as o } from "./context.js";
import { removeOverlay as f, closeOverlay as c, openOverlay as v, updateOverlay as p } from "./overlay.js";
import { on as d, off as h, preventDefault as m } from "../../utils/dom/event.js";
import { removeNode as y } from "../../utils/dom/node.js";
import { getScroller as k } from "../../utils/dom/scroll.js";
import { TouchMixin as x } from "../touch.js";
import { PortalMixin as C } from "../portal.js";
import { CloseOnPopstateMixin as I } from "../close-on-popstate.js";
var S = {
  // Initial rendering animation
  transitionAppear: Boolean,
  // whether to show popup
  value: Boolean,
  // whether to show overlay
  overlay: Boolean,
  // overlay custom style
  overlayStyle: Object,
  // overlay custom class name
  overlayClass: String,
  // whether to close popup when overlay is clicked
  closeOnClickOverlay: Boolean,
  // z-index
  zIndex: [Number, String],
  // prevent body scroll
  lockScroll: {
    type: Boolean,
    default: !0
  },
  // whether to lazy render
  lazyRender: {
    type: Boolean,
    default: !0
  }
};
function $(r) {
  return r === void 0 && (r = {}), {
    mixins: [x, I, C({
      afterPortal: function afterPortal() {
        this.overlay && p();
      }
    })],
    provide: function provide() {
      return {
        vanPopup: this
      };
    },
    props: S,
    data: function data() {
      return this.onReopenCallback = [], {
        inited: this.value
      };
    },
    computed: {
      shouldRender: function shouldRender() {
        return this.inited || !this.lazyRender;
      }
    },
    watch: {
      value: function value(e) {
        var i = e ? "open" : "close";
        this.inited = this.inited || this.value, this[i](), r.skipToggleEvent || this.$emit(i);
      },
      overlay: "renderOverlay"
    },
    mounted: function mounted() {
      this.value && this.open();
    },
    /* istanbul ignore next */
    activated: function activated() {
      this.shouldReopen && (this.$emit("input", !0), this.shouldReopen = !1);
    },
    beforeDestroy: function beforeDestroy() {
      f(this), this.opened && this.removeLock(), this.getContainer && y(this.$el);
    },
    /* istanbul ignore next */
    deactivated: function deactivated() {
      this.value && (this.close(), this.shouldReopen = !0);
    },
    methods: {
      open: function open() {
        this.$isServer || this.opened || (this.zIndex !== void 0 && (o.zIndex = this.zIndex), this.opened = !0, this.renderOverlay(), this.addLock(), this.onReopenCallback.forEach(function (e) {
          e();
        }));
      },
      addLock: function addLock() {
        this.lockScroll && (d(document, "touchstart", this.touchStart), d(document, "touchmove", this.onTouchMove), o.lockCount || document.body.classList.add("van-overflow-hidden"), o.lockCount++);
      },
      removeLock: function removeLock() {
        this.lockScroll && o.lockCount && (o.lockCount--, h(document, "touchstart", this.touchStart), h(document, "touchmove", this.onTouchMove), o.lockCount || document.body.classList.remove("van-overflow-hidden"));
      },
      close: function close() {
        this.opened && (c(this), this.opened = !1, this.removeLock(), this.$emit("input", !1));
      },
      onTouchMove: function onTouchMove(e) {
        this.touchMove(e);
        var i = this.deltaY > 0 ? "10" : "01",
          s = k(e.target, this.$el),
          l = s.scrollHeight,
          a = s.offsetHeight,
          u = s.scrollTop,
          n = "11";
        u === 0 ? n = a >= l ? "00" : "01" : u + a >= l && (n = "10"), n !== "11" && this.direction === "vertical" && !(parseInt(n, 2) & parseInt(i, 2)) && m(e, !0);
      },
      renderOverlay: function renderOverlay() {
        var e = this;
        this.$isServer || !this.value || this.$nextTick(function () {
          e.updateZIndex(e.overlay ? 1 : 0), e.overlay ? v(e, {
            zIndex: o.zIndex++,
            duration: e.duration,
            className: e.overlayClass,
            customStyle: e.overlayStyle
          }) : c(e);
        });
      },
      updateZIndex: function updateZIndex(e) {
        e === void 0 && (e = 0), this.$el.style.zIndex = ++o.zIndex + e;
      },
      onReopen: function onReopen(e) {
        this.onReopenCallback.push(e);
      }
    }
  };
}
export { $ as PopupMixin, S as popupMixinProps };
